import { SessionStore } from './session-store.ts';
import type { AppliedPromoCode, ReservationConfig } from './types.ts';

export interface StandardReservation {
  specialityId: string;
  description: string;
  scheduledDate?: string;
  scheduledMinutes?: number;
  timezone?: string;
  files?: string[];
  patientName?: string;
  patientBirthDate?: string;
  patientGender?: string;
  doctorName?: string;
  guestEmail?: string;
  appliedPromo?: AppliedPromoCode;
}

export type StandardReady = StandardReservation & {
  scheduledDate: string;
  scheduledMinutes: number;
  timezone: string;
};

export function isStandardReady(r: StandardReservation): r is StandardReady {
  return (
    typeof r.scheduledDate === 'string' &&
    typeof r.scheduledMinutes === 'number' &&
    typeof r.timezone === 'string'
  );
}

export const standardReservationStore = new SessionStore<StandardReservation>(
  'standard-reservation',
);

export const STANDARD_RESERVATION: ReservationConfig<StandardReservation> = {
  store: standardReservationStore,
};
